<div class="container h-100 align-items-center">
  <div *ngIf="isLoading" class="row h-100 justify-content-center align-items-center">
    <div class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
  <div class="row justify-content-center align-items-center VerticalMargin mb-5" *ngIf="isLoading == false">
    <div class="card RegularForm rounded col-12 col-xs-9 col-lg-8" 
      [class.SmallArabicFont]="globalService.isRTL == true">
      <div class="card-body MyCardBody rounded-bottom">
        <div>
          <div class="row mb-5" *ngIf="
          forms.length == 0
          ">
            <div class="col-12 text-center text-dark" [class.SmallArabicFont]="globalService.isRTL == true">
              <br /><br /><br />
              {{ globalService.Get("NODATA") }}
            </div>
          </div>
          <div class="form-group col-12 mt-4" *ngFor="let form of forms">
            <button class="btn btn-block btn-primary text-left" type="button" (click)="gotoForm(form.id)">
              <span [class.SmallArabicFont]="globalService.isRTL == true">
                {{ form.name }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>